module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/MARKETING-af872b769109fbcb38ecf22dfb4087ff.png";